import { ref, watch } from 'vue';
import MessageTemplatesAPI from 'dashboard/api/messageTemplates';

/**
 * Templates created in Corvus with named variables (spec 133 v4) only keep that
 * friendly name locally — the Meta-synced copy used when actually sending a template
 * only has positional placeholders ({{1}}, {{2}}). This matches the synced template by
 * name to the local record so the fill-in form can show the friendly name instead.
 */
export function useWhatsappTemplateVariableLabels(inboxIdRef) {
  const variableLabelsByName = ref({});

  const fetchLabels = async inboxId => {
    if (!inboxId) {
      variableLabelsByName.value = {};
      return;
    }

    try {
      const { data } = await MessageTemplatesAPI.get(inboxId);
      variableLabelsByName.value = (data.payload || []).reduce(
        (map, template) => {
          if (template.variable_labels?.length) {
            map[template.name] = template.variable_labels;
          }
          return map;
        },
        {}
      );
    } catch (error) {
      variableLabelsByName.value = {};
    }
  };

  watch(inboxIdRef, fetchLabels, { immediate: true });

  const withVariableLabels = template => {
    const labels = template?.name && variableLabelsByName.value[template.name];
    return labels ? { ...template, variable_labels: labels } : template;
  };

  return { withVariableLabels };
}
